export {};

const MOBILE_SLIDER_SELECTOR = '.js-mobile-tabs-slider';

$(mobileSliderTabsInit);

NLMK.mobileSliderTabssInit = mobileSliderTabsInit;
NLMK.slickAPI = slickAPI();

function mobileSliderTabsInit() {
    const isFromVerticalTablet = matchMedia(`(min-width: ${NLMK.mediaQueries.verticalTablet.min}px)`);
    const isAtMobile = matchMedia(`(max-width: ${NLMK.mediaQueries.mobile.max}px)`);

    const $mobilesSliders = $(MOBILE_SLIDER_SELECTOR);

    $mobilesSliders.each(eachSlider);

    function eachSlider(sliderIndex, Slider) {
        const $slider = $(Slider);
        const tabsSelector = $slider.data('tabs-selector');
        const infinite = $slider.data('infinite');
        const $tabs = $(tabsSelector);

        const { nextArrow, prevArrow } = makeArrows();

        const settings = {
            dots: false,
            arrows: true,
            infinite: typeof infinite !== 'undefined' && !!infinite,
            slidesToShow: 1,
            nextArrow,
            prevArrow,
            mobileFirst: true,
        };

        let prevInnerWidth = innerWidth;

        if (tabsSelector) {
            $slider.on('afterChange', changeTabs);
        }

        $slider.on('init', onInit).slick(settings);

        $(window).on('resize', $.debounce(100, onResize));

        toggleSliderIfNeeded();

        function makeArrows() {
            const NextArrow = document.createElement('div');
            const PrevArrow = document.createElement('div');

            const arrowNextClassList = $slider.data('arrow-next-class-list');
            const arrowPrevClassList = $slider.data('arrow-prev-class-list');

            PrevArrow.innerHTML = NLMK.generateSlickArrow('left', 'prev');
            NextArrow.innerHTML = NLMK.generateSlickArrow('right', 'next');

            if (arrowNextClassList) {
                NextArrow.firstChild.className = arrowNextClassList;
            }

            if (arrowPrevClassList) {
                PrevArrow.firstChild.className = arrowPrevClassList;
            }

            return {
                nextArrow: NextArrow.innerHTML,
                prevArrow: PrevArrow.innerHTML,
            };
        }

        function destroySlider() {
            $slider.slick('unslick');
        }

        function onResize() {
            if (prevInnerWidth !== innerWidth) {
                prevInnerWidth = innerWidth;

                toggleSliderIfNeeded();
            }
        }

        function toggleSliderIfNeeded() {
            const isSlickInitialized = $slider.hasClass('slick-initialized');

            if (isFromVerticalTablet.matches && isSlickInitialized) {
                destroySlider();
            }

            if (isAtMobile.matches && !isSlickInitialized) {
                $slider.slick(settings);
            }
        }

        function onInit() {
            $slider.css('visibility', 'visible');
        }

        function changeTabs() {
            const tabIndex = $slider
                .find('.slick-current')
                .find('.js-slide-index')
                .data('tabnumber');

            $tabs
                .find('[data-tabnumber="' + tabIndex + '"]')
                .css({
                    height: 'auto',
                    visibility: 'visible',
                    overflow: 'visible',
                })
                .addClass('active animated')
                .siblings()
                .css({
                    height: 0,
                    visibility: 'hidden',
                    overflow: 'hidden',
                })
                .removeClass('active animated');
        }
    }
}

function slickAPI() {
    return {
        slickGoTo: function($container, idx) {
            $container.slick('slickGoTo', idx - 1);
        },
    };
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/mobile-tabs.js